import type { ApiResponse } from "../factory";
import { BaseRepository } from "../factory";
import type { Catalog } from "./catalogs";

export type Settings = Setting[];

export interface Setting {
  id: number;
  key: string;
  value: string | null | Social[];
  created_at: string;
  updated_at: string;
}

export interface CoverSeparator {
  data: any;
  // | [
  //     {
  //       id: number;
  //       title: string;
  //       type: string;
  //       ext: string;
  //       description: string | null;
  //       url: string;
  //       alt: string | null;
  //       caption: string | null;
  //       created_at: string;
  //       updated_at: string;
  //     },
  //   ]
  // | {
  //     id: number;
  //     title: string;
  //     type: string;
  //     ext: string;
  //     description: string | null;
  //     url: string;
  //     alt: string | null;
  //     caption: string | null;
  //     created_at: string;
  //     updated_at: string;
  //   };
}

export interface Separator {
  type: string;
  cover: CoverSeparator;
  catalogs: Catalog[] | null;
  title: string | null;
  description: string | null;
}

export interface Social {
  name: string;
  link: string;
  icon: number;
}

export interface Breadcrumb {
  label: string;
  url: string;
}

export interface CatalogResponse {
  data?: Catalog[];
  array_key: string[];
}

export class SettingsRepository extends BaseRepository<Setting> {
  collection = "settings";
  language?: string;

  constructor(language?: string) {
    super();
    this.language = language;
  }

  getMany(
    queryParams?: Record<string, unknown>
  ): Promise<ApiResponse<Settings>> {
    return super.getMany(queryParams);
  }
}
